import { createFileRoute } from '@tanstack/react-router'

import Language from '@/signup/components/Language'

export const Route = createFileRoute('/signup/welcome/{-$uuid}')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Language />
}
